module.exports = __webpack_public_path__ + "static/media/colibrisbleu.49313c3d.png";